export type SparkApplicationType = 'Ordering' | 'Healthcare' | 'AI Answering';

export const shouldValidatePosConfig = (
    allowsTemplating: boolean,
    appType: SparkApplicationType,
    organizationHasDentalApplication: boolean = false
): boolean => !organizationHasDentalApplication && !allowsTemplating && appType !== 'Healthcare';
